export const ROOT_AUTH_ROUTE = '/auth';

export const AUTH_ROUTE = {
    SIGNIN: `${ROOT_AUTH_ROUTE}/signin`,
    SIGNUP: `${ROOT_AUTH_ROUTE}/signup`,
    RELOAD: `${ROOT_AUTH_ROUTE}/reload`,
    LOGOUT: `${ROOT_AUTH_ROUTE}/logout`,
};
